// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__BIt_b","colMin":"styles_colMin__1cFhh","colCheckbox":"styles_colCheckbox__GSEmW"};